import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { OutputInstruction, Output } from '../../../../../machinelogic/types';
import { LeftPaneContext } from '../../LeftPaneContext';

interface OutputInstructionProps extends InstructionNodeProps {
  instruction: OutputInstruction;
}

const getInstructionLabelName = (instruction: OutputInstruction, getOutputByUuid ): string => {
  switch(instruction.name) {
    case 'digitalOutput': {
      const output: Output = getOutputByUuid(instruction.parameters.outputUuid);
      const outputName = output?.name || "UNKNOWN Output";
      return `Set ${outputName} to ${instruction.parameters.value}`;
    }
    case 'generateEvent':
      return `Output '${instruction.parameters.topic}' Event`;
  }
};

export const OutputNode: FC<OutputInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {
  const { library } = useContext(LeftPaneContext);
  const getOutputByUuid = (uuid) => library.getConfigManager().getOutputByUuid(uuid);

  const instructionLabel = <TreeNodeLabel
    icon="icon-arrow-from-left"
    name={getInstructionLabelName(instruction, getOutputByUuid)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
